import { els } from './variables';
import { isMobileMenu } from './main-menu';

const headerSearch = {
	init() {
		this.form = document.querySelector('.site-header .search-form');
		if (this.form) {
			this.input = this.form.querySelector('.search-field');
			this.navTop = document.querySelector('.site-header__navigation-top');

			this.closeForm = this.closeForm.bind(this);
			document.addEventListener('click', this.closeForm);

			this.openForm = this.openForm.bind(this);
			this.form.addEventListener('click', this.openForm);
			this.handleInvalid = this.handleInvalid.bind(this);
			this.input.addEventListener('invalid', this.handleInvalid);
		}
	},

	closeForm() {
		this.form.classList.remove('open');
		this.navTop.classList.remove('search-is-open');
		this.input.value = '';
	},

	openForm(e) {
		e.stopPropagation();
		this.form.classList.add('open');
		this.navTop.classList.add('search-is-open');
	},

	handleInvalid() {
		if (isMobileMenu()) {
			els.navContainer.scrollTop = els.navContainer.scrollHeight;
		}
	},
};

headerSearch.init();
